const _ = require('lodash');
const LandingAirReservationSearchForm = require('swa-landing-page/landing-air-reservation-search-form');
const classNames = require('classnames');
const CorporateLandingHomePageChangeCancelSelectorPanels = require('./corporate-landing-home-page-change-cancel-selector-panels');
const Heading = require('swa-components-core/heading');
const i18n = require('swa-locale/i18n');
const PropTypes = require('prop-types');
const React = require('react');
const TabbedArea = require('swa-components-core/tabbed-area');
const TabPanel = require('swa-components-core/tab-panel');

const TAB_INDEX_CHANGE = 0;

class CorporateLandingHomePageChangeCancelSelector extends React.Component {
    static propTypes = {
        cancelFormProps: PropTypes.object.isRequired,
        changeFormProps: PropTypes.object.isRequired,
        className: PropTypes.string
    };

    state = {
        activeForm: TAB_INDEX_CHANGE
    };

    render() {
        return (
            <div className={this.getClass()}>
                {this.renderHeading()}
                <TabbedArea {...this.getTabbedAreaProps()}>
                    {this.renderNavigationPanel(CorporateLandingHomePageChangeCancelSelectorPanels.change)}
                    {this.renderNavigationPanel(CorporateLandingHomePageChangeCancelSelectorPanels.cancel)}
                </TabbedArea>
            </div>
        );
    }

    renderHeading = () => (
        <Heading {...this.getHeadingProps()}>
            {i18n('TITLE__CHANGE_OR_CANCEL')}
        </Heading>
    );

    renderNavigationPanel = (tab) => (
        <TabPanel {...this.getTabPanelProps(tab)}>
            {this.renderTabContent(tab)}
        </TabPanel>
    );

    renderTabContent = (tab) => {
        let contentToRender = null;
        const Component = tab.content;

        if (Component) {
            contentToRender = (
                <Component>
                    <LandingAirReservationSearchForm {...this.getTabFormProps(tab.name)} />
                </Component>
            );
        }

        return contentToRender;
    };

    getTabFormProps = (tabName) => _.assign({}, this.props[`${tabName}FormProps`], { key: tabName });

    getTabbedAreaProps = () => ({
        animate: true,
        buttonType: 'actionable-toggle',
        name: 'change-cancel',
        onTabSelect: this.handleTabSelect,
        selectedTabIndex: this.state.activeForm
    });

    getTabPanelProps = (tab) => ({
        tabClassName: 'change-cancel-selector--tab',
        tabName: tab.name,
        tabTitle: i18n(tab.title)
    });

    getHeadingProps = () => ({
        className: 'change-cancel-selector--heading',
        id: _.uniqueId('heading-'),
        size: 'medium'
    });

    getClass = () => classNames('corporate-landing-home-page-change-cancel-selector', this.props.className);

    handleTabSelect = (selectedTabIndex) => {
        this.setState({ activeForm: selectedTabIndex });
    };
}

module.exports = CorporateLandingHomePageChangeCancelSelector;
